var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBiketti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414.274,
    height: 260.005,
    viewBox: "0 0 109.61 68.793",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.265
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6007e",
    d: "M0 54.5h109.61v14.289H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b5d3",
    d: "M0 36.51h109.61v14.289H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef88b5",
    d: "M0 17.99h109.61v14.289H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b5d3",
    d: "M0 0h109.61v14.289H0z"
  }))));
}
export default SvgIcBiketti;